/* ============================================================
   BS24 Nachladen + Positionsgedaechtnis   (20.08.2026)
   ------------------------------------------------------------
   A) Nachladen holt nur noch den Produkt-Abschnitt statt der
      kompletten naechsten Seite.
      Gemessen: 867 KB / 1103 ms  ->  269 KB / 669 ms
   B) Scrollposition und Anzahl geladener Seiten werden selbst
      gemerkt und beim Zurueckkommen wiederhergestellt —
      unabhaengig vom Zurueck-Cache des Browsers.
      Damit funktioniert es auch auf iPhones, wo Safari die
      Seite haeufig verwirft.

   Die alte Fassung holte die ganze Seite per jQuery und warf
   90 % davon weg. Sie steht als assets/load-more-alt.js.bak
   weiterhin auf dem Server.
   ============================================================ */
(function () {
  'use strict';

  var GRID          = '.load-more-grid';
  var MAX_SEITEN    = 15;             /* Obergrenze beim Wiederherstellen */
  var MAX_ALTER     = 30 * 60 * 1000; /* gemerkte Position 30 Minuten gueltig */
  var VORLAUF       = '700px';        /* laedt schon vor dem Seitenende */

  var laedt = false;
  var beobachter = null;

  /* ---------- kleine Helfer ---------- */
  function gitter()  { return document.querySelector(GRID); }
  function feld(n)   { return document.querySelector('[' + n + ']'); }
  function zahl(n, ersatz) {
    var el = feld(n);
    var v  = el ? parseInt(el.value, 10) : NaN;
    return isNaN(v) ? ersatz : v;
  }
  function abschnittsId() {
    var el = document.getElementById('product-grid');
    return el && el.dataset ? el.dataset.id : null;
  }

  /* ---------- A: Adresse fuer die Abschnitts-Auslieferung ---------- */
  function seitenAdresse(seite) {
    var url = new URL(window.location.href);
    url.searchParams.set('page', seite);
    url.searchParams.delete('phcursor');
    var sid = abschnittsId();
    if (sid) url.searchParams.set('section_id', sid);
    return url.pathname + '?' + url.searchParams.toString();
  }

  function holen(seite) {
    return fetch(seitenAdresse(seite), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .catch(function () { return ''; });
  }

  function einbauen(html) {
    if (!html) return 0;
    var doc    = new DOMParser().parseFromString(html, 'text/html');
    var quelle = doc.querySelector(GRID);
    var ziel   = gitter();
    if (!quelle || !ziel) return 0;
    var n = quelle.children.length;
    ziel.insertAdjacentHTML('beforeend', quelle.innerHTML);
    return n;
  }

  function nachbereiten(neueSeite) {
    var f = feld('data-current-page');
    if (f) { f.value = neueSeite; f.dataset.currentPage = neueSeite; }
    if (typeof colorSwatches === 'function') { try { colorSwatches(); } catch (e) {} }
    if (typeof window.updateShowingText === 'function') window.updateShowingText();
  }

  /* ---------- Nachladen ---------- */
  function nachladen(ausloeser) {
    if (laedt) return;
    var gesamt  = zahl('data-total-pages', 1);
    var aktuell = zahl('data-current-page', 1);
    if (aktuell >= gesamt) {
      if (ausloeser && ausloeser.classList.contains('js-load-more')) ausloeser.remove();
      return;
    }
    laedt = true;
    var naechste = aktuell + 1;
    if (ausloeser) { ausloeser.setAttribute('disabled', ''); ausloeser.classList.add('loading'); }

    holen(naechste).then(function (html) {
      einbauen(html);
      nachbereiten(naechste);
      merken();
      if (ausloeser) {
        ausloeser.removeAttribute('disabled');
        ausloeser.classList.remove('loading');
        if (naechste >= gesamt && ausloeser.classList.contains('js-load-more')) ausloeser.remove();
      }
    }).then(function () {
      laedt = false;
      beobachten();
    }, function () {
      laedt = false;
      if (ausloeser) { ausloeser.removeAttribute('disabled'); ausloeser.classList.remove('loading'); }
    });
  }

  function beobachten() {
    var spinner = document.querySelector('.js-infinite-scroll');
    if (!spinner) return;
    if (beobachter) beobachter.disconnect();
    beobachter = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) { if (e.isIntersecting) nachladen(spinner); });
    }, { rootMargin: VORLAUF + ' 0px' });
    beobachter.observe(spinner);
  }

  function knoepfe() {
    document.querySelectorAll('.js-load-more').forEach(function (b) {
      b.onclick = function () { nachladen(b); };
    });
  }

  /* ---------- B: Position und geladene Seiten merken ---------- */
  function schluessel() {
    var url = new URL(window.location.href);
    url.searchParams.delete('page');
    url.searchParams.delete('phcursor');
    url.searchParams.delete('section_id');
    return 'bs24:liste:' + url.pathname + url.search;
  }

  function merken() {
    try {
      sessionStorage.setItem(schluessel(), JSON.stringify({
        y: Math.round(window.pageYOffset || window.scrollY || 0),
        s: zahl('data-current-page', 1),
        t: Date.now()
      }));
    } catch (e) {}
  }

  function gemerkt() {
    try {
      var roh = sessionStorage.getItem(schluessel());
      if (!roh) return null;
      var d = JSON.parse(roh);
      if (!d || !d.t || (Date.now() - d.t) > MAX_ALTER) return null;
      return d;
    } catch (e) { return null; }
  }

  function kommtVonProdukt() {
    var nav = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    if (nav && nav.type === 'back_forward') return true;
    return (document.referrer || '').indexOf('/products/') > -1;
  }

  function scrollenAuf(y) {
    var versuche = 0;
    (function tick() {
      window.scrollTo(0, y);
      versuche++;
      if (Math.abs((window.pageYOffset || 0) - y) > 4 && versuche < 15) setTimeout(tick, 120);
    })();
  }

  function wiederherstellen() {
    var d = gemerkt();
    if (!d || !kommtVonProdukt()) return;
    if (!gitter()) return;

    var gesamt = zahl('data-total-pages', 1);
    var ziel   = Math.min(d.s || 1, gesamt, MAX_SEITEN);

    if (ziel <= 1) { scrollenAuf(d.y); return; }

    laedt = true;
    var auftraege = [];
    for (var p = 2; p <= ziel; p++) auftraege.push(holen(p));

    Promise.all(auftraege).then(function (liste) {
      /* 22.08.2026: nur lueckenlos einbauen - schlaegt eine mittlere
         Seite fehl, stoppt der Einbau davor und der Seitenzaehler
         stimmt mit dem Eingebauten ueberein. */
      var geschafft = 1;
      for (var i = 0; i < liste.length; i++) {
        if (!liste[i]) break;
        einbauen(liste[i]);
        geschafft = i + 2;
      }
      nachbereiten(geschafft);
      laedt = false;
      beobachten();
      scrollenAuf(d.y);
    }, function () {
      laedt = false;
      scrollenAuf(d.y);
    });
  }

  /* ---------- Anzeige "Showing x of y" (unveraendert) ---------- */
  window.updateShowingText = function () {
    if (!window.jQuery) return;
    var $ = window.jQuery;
    var currentPage   = parseInt($('[data-current-page]').val(), 10);
    var totalProducts = parseInt($('[data-total-products]').val(), 10);
    var perPage       = $('[data-per-page]').data('per-page');
    if (isNaN(currentPage) || isNaN(totalProducts)) return;
    if (totalProducts <= perPage) currentPage = 1;
    var text = totalProducts === 1 ? 'product' : 'products';
    var productsShowing = Math.min(currentPage * perPage, totalProducts);
    $('.showing-text').text('Showing ' + productsShowing + ' of ' + totalProducts + ' ' + text);
  };

  /* ---------- nach aussen sichtbar (facets.js ruft loadMore auf) ---------- */
  window.checkVisibility = beobachten;
  window.loadMore = function () {
    knoepfe();
    beobachten();
    if (typeof window.updateShowingText === 'function') window.updateShowingText();
  };

  /* ---------- Start ---------- */
  var merkTimer = null;
  window.addEventListener('scroll', function () {
    if (merkTimer) return;
    merkTimer = setTimeout(function () { merkTimer = null; merken(); }, 400);
  }, { passive: true });
  window.addEventListener('pagehide', merken);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') merken();
  });

  function start() {
    window.loadMore();
    wiederherstellen();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  document.addEventListener('shopify:section:load', function () { window.loadMore(); });
})();